import { Link } from 'react-router-dom';
import { LOGO_BASE_URL } from '../../apiConfig';
import teamLogo from '../../images/team-logo.png';
import { Calendar, ChevronRight, Trophy } from 'lucide-react';
import { motion } from 'framer-motion';

function Result({ data }) {
    const isMobile = window.innerWidth <= 768;
    const accentYellow = '#E7C424';

    const styles = {
        card: {
            width: '100%',
            maxWidth: '512px',
            height: isMobile ? 'auto' : '212px',
            background: 'linear-gradient(180deg, #E7C424 0%, #322901 100%)',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            color: 'white',
            position: 'relative',
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.1)',
        },
        headerPill: {
            alignSelf: 'center',
            background: '#FFFFFF',
            padding: '4px 16px',
            borderRadius: '24px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            marginBottom: '12px',
            maxWidth: '90%',
            display: 'flex',
            justifyContent: 'center',
        },
        resultText: {
            fontFamily: 'var(--fontAnton)',
            fontWeight: 400,
            fontSize: isMobile ? '12px' : '14px',
            color: '#060D8A',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            margin: 0,
            textAlign: 'center',
            lineHeight: 1.1,
        },
        body: {
            display: 'grid',
            gridTemplateColumns: '1fr auto 1fr',
            alignItems: 'center',
            padding: isMobile ? '8px 0' : '4px 0',
            flex: 1,
            gap: isMobile ? '8px' : '16px',
        },
        teamBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px',
            minWidth: 0,
        },
        logoBox: {
            width: '48px',
            height: '48px',
            background: '#ffffff',
            borderRadius: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '6px',
            boxSizing: 'border-box',
            border: '2px solid rgba(255,255,255,0.15)',
        },
        teamName: {
            fontFamily: 'var(--fontAnton)',
            fontWeight: 400,
            fontSize: isMobile ? '12px' : '15px',
            textAlign: 'center',
            margin: 0,
            color: '#FFFFFF',
            textTransform: 'uppercase',
            lineHeight: 1.1,
            letterSpacing: '0.5px',
        },
        vsText: {
            fontFamily: 'var(--fontAnton)',
            fontSize: isMobile ? '24px' : '36px',
            fontWeight: 400,
            color: '#FFFFFF',
            opacity: 1,
            margin: 0,
            textShadow: '0 4px 20px rgba(0,0,0,0.3)',
        },
        footer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 0 0 0',
            background: 'transparent',
            borderTop: '1px solid rgba(255,255,255,0.1)',
        },
        dateBox: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
        },
        dateText: {
            fontFamily: 'var(--fontInter)',
            fontWeight: 600,
            fontSize: '13px',
            color: '#FFFFFF',
            margin: 0,
        },
        scorecardBtn: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            fontFamily: 'var(--fontAnton)',
            fontWeight: 400,
            fontSize: '13px',
            color: '#FFFFFF',
            textDecoration: 'underline',
            textTransform: 'uppercase',
            letterSpacing: '0.8px',
        }
    };

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <motion.div 
            whileHover={{ y: -5, boxShadow: '0 15px 35px rgba(0,0,0,0.2)' }}
            style={styles.card}
        >
            {/* Header Pill */}
            <div style={styles.headerPill}>
                <p style={styles.resultText}>{data.msg}</p>
            </div>

            {/* Body */}
            <div style={styles.body}>
                <div style={styles.teamBox}>
                    <div style={styles.logoBox}>
                        <img 
                            src={data.left_team_logo ? `${LOGO_BASE_URL}/${data.left_team_logo}` : teamLogo} 
                            alt={data.left_club} 
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </div>
                    <p style={styles.teamName}>{data.left_club}</p>
                </div>

                <p style={styles.vsText}>V/S</p>

                <div style={styles.teamBox}>
                    <div style={styles.logoBox}>
                        <img 
                            src={data.right_team_logo ? `${LOGO_BASE_URL}/${data.right_team_logo}` : teamLogo} 
                            alt={data.right_club} 
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </div>
                    <p style={styles.teamName}>{data.right_club}</p>
                </div>
            </div>

            {/* Footer */}
            <div style={styles.footer}>
                <div style={styles.dateBox}>
                    <Calendar size={13} color="#FFFFFF" />
                    <p style={styles.dateText}>{data.match_date}</p>
                </div>
                {data.msg !== "Abandoned" && (
                    <Link 
                        to={"/view-score-card/" + data.id} 
                        style={styles.scorecardBtn} 
                        onClick={handleScrollToTop}
                    >
                        Scorecard <ChevronRight size={14} />
                    </Link>
                )}
            </div>
        </motion.div>
    );
}

export default Result;